import { useMemo } from 'react'
import { useGetStocksQuery } from '../../../../../../../../store/api/stocks-api'
import { DataSourceItem } from '../../../../../../shipments-page'
import { useGetStocksQueryArg } from './use-get-stocks-query-arg'

/**
 * Загружает все остатки по конфигурируемым материалам
 */
export const useMaterialRequirementsStocks = (record: DataSourceItem | undefined) => {
    const materialDocIds = useMemo(
        () =>
            Array.from(
                new Set(
                    (record?.materialRequirements || [])
                        .flatMap(requirement => requirement.configurations || [])
                        .map(config => config.material?.documentId)
                        .filter(Boolean)
                )
            ) as string[],
        [record]
    )
    const getStocksQueryArg = useGetStocksQueryArg({ materialDocIds })
    const { data: stocksData } = useGetStocksQuery(getStocksQueryArg, {
        skip: materialDocIds.length === 0,
    })

    return stocksData?.data || []
}
